import { FC } from 'react';
import { Svg } from '../model/svg';

const Close: FC<Svg> = ({
  width = '14',
  height = '14',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={'0 0 14 14'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path d="M13.3002 0.709727C12.9102 0.319727 12.2802 0.319727 11.8902 0.709727L7.00022 5.58973L2.11022 0.699727C1.72022 0.309727 1.09021 0.309727 0.700215 0.699727C0.310215 1.08973 0.310215 1.71973 0.700215 2.10973L5.59022 6.99973L0.700215 11.8897C0.310215 12.2797 0.310215 12.9097 0.700215 13.2997C1.09021 13.6897 1.72022 13.6897 2.11022 13.2997L7.00022 8.40973L11.8902 13.2997C12.2802 13.6897 12.9102 13.6897 13.3002 13.2997C13.6902 12.9097 13.6902 12.2797 13.3002 11.8897L8.41021 6.99973L13.3002 2.10973C13.6802 1.72973 13.6802 1.08973 13.3002 0.709727Z" />
  </svg>
);

export default Close;
